<template>
  <div class="i-resources">
    <iResourceCard
      v-for="(resource, index) in RESOURCE_DATA"
      :key="resource.title"
      :is-first="index === 0"
      v-bind="resource"
    />
  </div>
</template>

<script setup lang="ts">
import { bilbao200, black50, riptide200, sorbus100 } from "@/styles/colors"

import iResourceCard from "@/components/report/resources/ResourceCard.vue"

// ASSETS
import ImageMentor from "@/assets/resources/Resource_Mentor.png"
import ImageBold from "@/assets/resources/Resource_Bold.png"
import ImageIpsos from "@/assets/resources/Resource_Ipsos.png"
import ImageNotion from "@/assets/resources/Resource_Notion.png"
import ImageCatfish from "@/assets/resources/Resource_Catfish.png"

// TYPES
interface ResourceType {
  title: string
  info: string
  ctaText: string
  ctaAction: () => void
  image: string
  tag: string
  color: string
}

// CONSTANTS
const RESOURCE_DATA: ResourceType[] = [
  {
    title: "Start Your Own Business",
    info: "Start and grow your own business with experienced startup mentors. Validate your ideas and avoid making costly mistakes.",
    ctaText: "Talk to experts today",
    image: ImageMentor,
    ctaAction: () => openUrl("https://www.growthmentor.com/?ref=6724dff8e3"),
    tag: "Entrepreneurship",
    color: bilbao200
  },
  {
    title: "No-Essay Scholarship",
    info: "Apply to no-essay scholarships to pursue additional education for your dream careers.",
    ctaText: "Apply in minutes",
    image: ImageBold,
    ctaAction: () => openUrl("https://bold.org/scholarships/the-be-bold-no-essay-scholarship/#ref=career-test"),
    tag: "Scholarship",
    color: sorbus100
  },
  {
    title: "Get Paid to Answer Survey Questions",
    info: "Share your opinions and get paid. Start earning rewards in your spare time.",
    ctaText: "Start earning now",
    image: ImageIpsos,
    ctaAction: () => openUrl("https://ipsosgroupgie.sjv.io/jobtestorg"),
    tag: "Earn Money",
    color: black50
  },
  {
    title: "Write, plan, and organize your life with ease",
    info: "Increase your productivity by using Notion, an award-winning tool.",
    ctaText: "Start for free",
    image: ImageNotion,
    ctaAction: () => openUrl("https://affiliate.notion.so/d5t5t1vujwrz"),
    tag: "Productivity",
    color: riptide200
  },
  {
    title: "Verify people you've met online",
    info: "Don't get scammed! - Verify people you've met online.",
    ctaText: "Verify now",
    image: ImageCatfish,
    ctaAction: () => openUrl("https://social-catfish.pxf.io/jobtestorg"),
    tag: "Life Hack",
    color: black50
  }
]

// FUNCTIONS
function openUrl(redirectUrl: string) {
  window.open(redirectUrl, "_blank")
}
</script>

<style scoped lang="scss">
.i-resources {
  margin-top: 10px;

  @include grid($cols: 1fr, $rows: auto, $align-items: stretch, $gap: 15px);

  @media screen and (min-width: $breakpoint-md) {
    @include grid($cols: 1fr 1fr, $rows: auto, $align-items: stretch, $gap: 25px);
  }

  @media screen and (min-width: $breakpoint-lg) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
